import axios from 'axios';
import Qs from 'qs';
import {
	dayEnd,
	dayStart,
} from "./DateUtil";

// const url = 'https://www.energydt.cn/api'  //公司线上服务器
const url = 'https://local.vrmaker.vip:37086'  //公司线上服务器


// 获取项目基本信息
export const GetBaseInfo = axiosApi('get', '/project/info');

// 获取能耗同环比
export const GetCompare = axiosApi('get', '/power/compare');

// 获取本年项目能耗
export const GetCurrentPowerInfo = axiosApi('get', '/power/current/year/powerAnalysis');

// 根据区域查询分合闸状态
export const GetCloseAndOpenNum = axiosApi('get', '/area/device/loop/inletLineStatus')

// 根据区域查询当前区域所有电柜数量
export const GetDeviceClassNum = axiosApi('get', '/device/area/class/number');

// 根据项目查询当前区域变压器数量
export const GetTransformerNum = axiosApi('get', '/device/project/class/number');

// 查询项目今日报警数量
export const GetTodayAlarmNum = axiosApi('get', '/alarm/num/day')

// 查询项目下所有报警
export const GetAlarmList = axiosApi('get', '/alarm/details/infos');

// 根据区域获取树形设备信息
export const GetDeviceTypeAndInfo = axiosApi('get', '/device/tree/area')

// 根据项目ID设备信息
export const GetDeviceByAreaId = axiosApi('get', '/device/project/all')

// 根据设备ID拿到回路
export const GetLoopsByDeviceId = axiosApi('get', '/loop/list')

// 通过区域ID查询区域所有回路
export const GetAllLoops = axiosApi('get','/loop/area/all')

// 获取项目的所有回路
export const GetAllLoopsByProjectId = axiosApi('get','/loop/all')

// 通过项目ID拿到项目的所有接线图
export const GetDistribution = axiosApi('get', './diagram/wiring/tree')

// 通过项目ID拿到项目的所有区域信息
export const GetAllAreas = axiosApi('get', '/area/project/all')

// 通过区域ID拿到区域的所有变压器
export const GetAllTransformer = axiosApi('get', '/device/transformer/list')

// 通过区域ID拿到区域的所有安防设备
export const GetAllSecurity = axiosApi('get', '/device/security/all')

// 通过项目ID拿到主进线回路
export const GetLoopMaster = axiosApi('get', '/loop/master')

// 通过区域Id判断当前区域是否有变压器、监控、进线柜、馈线柜
export const GetDeviceNumberByAreaId = axiosApi('get', '/device/area/tsclass')

// 通过设备id拿到设备信息
export const GetDeviceByDeviceId = axiosApi('get', '/device/details')

// 通过项目id拿到负荷率
export const GetLoadInfo = axiosApi('get', '/diagram/influxdb/data/load')

// 变压器总容量 
export const getCapacity = axiosApi('get', '/device/transformer/capacity/project')

// 通过回路id查询极值
export const EXTREMUM_VALUES = (ids, nodes, type, date) => {
	return axiosApi("get", "/extremum/values")({
		ids: ids.join(","),
		nodes: nodes.join(","),
		type,
		"start": dayStart(date),
		"end": dayEnd(date),
	})
}

/**
 * 用Create方法来创建axios请求对象
 */

export const INITAXIOS = axios.create({
    timeout: 20000, // 请求超时时间
    baseURL: url, //线上公司服务器
    method: 'post',
    headers: {
        'Content-Type': "application/x-www-form-urlencoded",
    },
    transformRequest: data => {
        let result = Qs.stringify(data);
        return result
    }
})

/**
 * 用来创建普通请求方法
 * @param api
 * @returns {function(*=): Promise<AxiosResponse<T>>}
 */
export function axiosApi(type, api, header) {
    header ? header : header = {};
    return data => {
        switch (type) {
            case 'get':
                return INITAXIOS({
                    url: api,
                    params: data,
                    method: 'get',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
            case 'post':
                return INITAXIOS({
                    url: api,
                    data: data,
                    method: 'post',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
            case 'put':
                return INITAXIOS({
                    url: api,
                    data: data,
                    method: 'put',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
            case 'delete':
                return INITAXIOS({
                    url: api,
                    data: data,
                    method: 'delete',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
        }
    }
}